import { render, staticRenderFns } from "./TrasladoCPCfdiRelacionado.vue?vue&type=template&id=27693f28&"
import script from "./TrasladoCPCfdiRelacionado.vue?vue&type=script&lang=js&"
export * from "./TrasladoCPCfdiRelacionado.vue?vue&type=script&lang=js&"
import style0 from "./TrasladoCPCfdiRelacionado.vue?vue&type=style&index=0&id=27693f28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports